import { render, staticRenderFns } from "./TappeItinerario.vue?vue&type=template&id=84f80094&"
import script from "./TappeItinerario.vue?vue&type=script&lang=js&"
export * from "./TappeItinerario.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports